import { Currency, ETHER, Token } from '@uniswap/sdk'
import { getActiveChainConfig } from '../constants/chains'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return getActiveChainConfig().nativeCurrency.symbol
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
